import { render } from "./notificationNavComponent.vue?vue&type=template&id=110a7677&scoped=true"
import script from "./notificationNavComponent.vue?vue&type=script&lang=js"
export * from "./notificationNavComponent.vue?vue&type=script&lang=js"

import "./notificationNavComponent.vue?vue&type=style&index=0&id=110a7677&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-110a7677"]])

export default __exports__